import React from "react";
import "./ErrorBoundary.css"; // Import SCSS file

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-container">
          <div className="error-content">
            <h1>Oops! Something went wrong 😢</h1>
            <p>We're sorry, but an error occurred while loading the page.</p>
            <button onClick={() => window.location.reload()}>Reload Page</button>
          </div>
          <div className="animation-container">
            <div className="error-icon">⚠️</div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
